import {closeSnackbar} from "../redux/actions/snackbarActions";
import React from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import store from "../redux/store";
import i18n from "../i18n";

// Pre-translated static messages using i18n.t() outside of React components
export const deleteSuccessMessage = {
  open: true,
  variant: 'success',
  message: i18n.t('alerts:deleteSuccess'),
};

export const sentEmailMessage = {
  open: true,
  variant: 'success',
  message: i18n.t('alerts:emailSent'),
};

// Helper to build the close action button for snackbars
function buildCloseAction(key) {
  return (
    <IconButton key="close" aria-label="close" color="inherit" onClick={() => store.dispatch(closeSnackbar(key))}>
      <CloseIcon />
    </IconButton>
  );
}

export function successMessage(item_message) {
  return {
    open: true,
    message: `${item_message}`,
    options: {
      variant: 'success',
      autoHideDuration: 12000,
      key: new Date().getTime(),
      action: buildCloseAction,
    }
  };
}

export function errorMessage(item_message) {
  return {
    open: true,
    message: `${item_message}`,
    options: {
      variant: 'error',
      autoHideDuration: 12000,
      key: new Date().getTime(),
      action: buildCloseAction,
    }
  };
}

export function warningMessage(item_message) {
  return {
    open: true,
    message: `${item_message}`,
    options: {
      variant: 'warning',
      autoHideDuration: 12000,
      key: new Date().getTime(),
      action: buildCloseAction,
    }
  };
}
